<template>
    
    <div>
        <ion-grid>
            <ion-row v-if="displayReportist">
                <ion-col v-for="report in this.reportList" :key="report" size="4" @click="reportDetails(report)">
                    <ion-row class="container-div">
                        <ion-col size="10">
                            <p class="usage-txt">{{report.description}}</p>
                        </ion-col>
                        <ion-col size="2">
                            <ion-icon :icon="arrowForwardOutline" class="custom-icon"></ion-icon>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
    
</template>

<script>
import { IonCol, IonGrid, IonIcon, IonRow} from "@ionic/vue";
import { defineComponent } from "vue";
import { arrowForwardOutline, receiptOutline } from 'ionicons/icons';
import Chart from 'chart.js/auto';
import { ToastUtils } from "../../util/toast-utils";
import { CorporateService } from "../../service/corporate/corporate.service";
import { migratedTryParseServiceError } from "../../service";

export default defineComponent({
    name: 'cpoReport',
    components:{
        IonIcon, IonGrid, IonRow, IonCol, IonIcon
    },
    data(){
        return{
            receiptOutline,
            arrowForwardOutline,
            reportList : [],
            chartInstance: null, // To hold the Chart.js instance
            chartData: {
                labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"],// X-axis data
                datasets: [
                {
                    backgroundColor:['#fcb268',],
                    label: "Energy consumed for last 30 days",
                    data: [1, 3, 2, 3, 1, 5, 4, 1, 3, 2, 3, 1, 5, 6,1, 3, 2, 3, 1, 5, 8,], // Initial Y-axis data
                    // borderColor: "rgb(75, 192, 192)",
                    borderColor: "#f7b807",
                    fill: false,
                },
                ],
            },
            displayReportist: false
        }
    },
    async mounted() {
        // this.createChart();
        this.getReportList(); 

    },
    beforeUnmount() {
        if (this.chartInstance) {
        this.chartInstance.destroy(); // Clean up the chart instance when the component is unmounted
        }
    },
    methods: {
        async getReportList() {
            try {
                this.loaderTab = true;
                this.reportList = await new CorporateService().getReportList();
                this.displayReportist = true;
                this.loaderTab = false;
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
        reportDetails(report) {
            if(report.code == "UsageReport") {
                this.$router.push('/corporate/usageReport')
            }
            
        },
        createChart() {
            const ctx = document.getElementById('myChart').getContext('2d');
            this.chartInstance = new Chart(ctx, {
                type: "bar", 
                data: this.chartData,
                options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: false, 
                    },
                    tooltip: {
                        enabled: false, 
                    },
                },
                scales: {
                    x: {
                    display: false, 
                    },
                    y: {
                    display: false, 
                    },
                },
                },
            });
        }
    },
})
</script>

<style scoped>
.card-container{
    margin-top: 30px;
}
.custom-icon{
    cursor: pointer;
    color: #ffff;
    font-size: 14px;
    font-weight: bold;
    padding: 8px;
    margin-top: 20px;
    background-color: #099c14;
    border-radius: 50%;
    /* border: 2px solid black; */
}
ion-card-title{
    font-weight: bold;
}
ion-card-subtitle{
    color: #cc6b16;
}
.view-details{
    color: #099c14;
    text-align: center;
}
.card-subtitle{
    color: #1520ed;
    font-size: 11px;
}
.chart-container {
  width: 100%;
  height: 120px;
  /* padding: 10px; */
}
.container-div{
    /* width: 30%; */
    margin-top: 20px;
    border: 2px solid rgb(240, 236, 236);
    border-radius: 20px;
    box-shadow: 2px 2px rgb(70, 68, 68);
    
}
.usage-txt{
    font-size: 22px;
    text-align: center;
}
</style>
